import '@babel/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'

import 'styles.css'
import App from 'scenes/App'
import {unregister} from 'serviceWorker'

ReactDOM.render(<App />, document.getElementById('root'))
unregister()
